import { Response } from '../../../services/api/types'
import { axios } from 'lib'
import { useQuery } from 'react-query'
import { toast } from 'react-toastify'

type Params = {
  orderId: string
}

export type Charge = {
  chargeId: number
  status: string
  observation: string
  sequence: string
  carrier: {
    id: string
    name: string
    plate: string
  }
  driver: {
    id: string
    name: string
    phone: string
  }
}

const loadOrderCharges = ({ orderId }: Params): Response<Charge[]> => {
  const page = 1
  const limit = 100

  return axios.get(`/orders/${orderId}/charges`, {
    params: {
      page,
      limit,
      search: ''
    }
  })
}

export function useLoadOrderCharges(params: Params) {
  return useQuery(['orderCharges', params], () => loadOrderCharges(params), {
    enabled: !!params.orderId,
    onError: () =>
      toast.error('Não foi possível carregar as cargas!', {
        toastId: 'orderCharges'
      })
  })
}
